/**
 * Mốc bố cục responsive của các màn đã làm responsive — cụm "Nạp thẻ trên ERP" (Figma file `2v3ndCYGh8NDArJrA4iJ4W`,
 * section "Nạp thẻ trên ERP - Responsive", node `20:5653`, khung 375px) và màn "Quản lý điểm thưởng" vẽ kèm trong
 * section đó. Figma chỉ có khung ĐIỆN THOẠI; mức máy tính bảng là yêu cầu thêm của người dùng (14/09/2026, "thêm cả
 * màn hình ipad"), không có frame.
 *
 * Ba mức:
 * - **mobile** ≤767px — theo đúng Figma: bảng thành danh sách thẻ một cột, thanh bước dựng dọc, drawer tràn màn hình.
 * - **tablet** 768–1199px — mọi iPad cả dọc (768–834) lẫn ngang (1024–1194), trừ iPad Pro 12.9" ngang (1366) vốn rộng
 *   như laptop. Chỗ trống thật của nội dung chỉ còn ~676–832px: dọc thì sidebar ẩn (app shell ẩn từ 1023px,
 *   `isMobileDevice()` ở `util/index.js`), NGANG thì sidebar 300px hiện lại. Bảng nào vừa chỗ đó thì giữ bảng; bảng
 *   phải cuộn ngang hoặc từng cắt nút (danh sách đơn cần 1100px, bảng giao dịch trong drawer cần ~736px) thì thành
 *   lưới thẻ HAI cột.
 * - **desktop** ≥1200px — như cũ.
 *
 * 🔴 SCSS dùng CÙNG con số — `$mobile-max-width`/`$tablet-max-width` ở `styles/common/_responsive.scss`. Đổi một bên
 * phải đổi bên kia, nếu không component render thẻ trong khi CSS còn bố cục bảng (hoặc ngược lại).
 */
export const MOBILE_MAX_WIDTH_PX = 767

export const TABLET_MAX_WIDTH_PX = 1199

/** Điện thoại. */
export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_MAX_WIDTH_PX}px)`

/** Điện thoại HOẶC máy tính bảng — mọi chỗ bảng rộng không còn đủ chỗ. */
export const COMPACT_MEDIA_QUERY = `(max-width: ${TABLET_MAX_WIDTH_PX}px)`

/**
 * Mốc thu gọn APP SHELL (sidebar + header của `views/defaultLayout`): ≤1023px thì sidebar 300px thành lớp phủ ẩn sẵn,
 * header hiện nút hamburger thay logo, nội dung bỏ lề trái 300px. Khác ba mức ở trên — đây là mốc của khung ứng dụng,
 * có từ trước đợt responsive.
 *
 * 🔴 CÙNG con số với `isMobileDevice()` (`util/index.js`, `window.innerWidth <= 1023`) và `@media (max-width: 1023px)` của
 * `styles/common/_sideBar.scss`/`_header.scss`/`_common.scss`. Ba chỗ đó là code cũ, KHÔNG đọc hằng này — đổi ở đây phải
 * đổi cả ba, nếu không `DefaultLayout` bỏ lề trái trong khi header vẫn hiện logo (hoặc ngược lại).
 */
export const APP_SHELL_COLLAPSED_MAX_WIDTH_PX = 1023

/** App shell thu gọn — `useAppShellSidebar` (`hook/useAppShellSidebar.ts`) theo dõi query này. */
export const APP_SHELL_COLLAPSED_MEDIA_QUERY = `(max-width: ${APP_SHELL_COLLAPSED_MAX_WIDTH_PX}px)`

/** Danh sách thẻ rỗng — cùng chữ với `Table.defaultProps.locale.emptyText` đặt ở `views/defaultLayout`. */
export const MOBILE_LIST_EMPTY_TEXT = 'Không có dữ liệu'
